import { Injectable } from '@angular/core';
import { MessageService } from 'primeng/api';
import { PnToastMessage } from './interfaces/toast.interfaces';

@Injectable({ providedIn: 'root' })
export class PnToastService {
    constructor(private messageService: MessageService) {}

    public show(message: PnToastMessage): void {
        this.messageService.add(message);
    }

    public showAll(messages: PnToastMessage[]): void {
        this.messageService.addAll(messages);
    }

    public clear(key?: string): void {
        this.messageService.clear(key);
    }
}
